import React from 'react';
import { FloatLabel } from '../../../Components';

interface IdentificationTutorPartialFormProps<T> {
    values: T;
    onChange: <K extends keyof T>(field: K, value: T[K]) => void;
    onChangeNumberCompany?: (value: string) => void;
    onKeyDownNumber?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    onBlurNumberCompany?: () => void;
    errors?: Partial<Record<keyof T, string>>;
    dictNameLabel: string;
    dictSurnameLabel: string;
    dictDenominationCompanyLabel: string;
    dictNumberCompanyLabel: string;
    dictSocialCompanyLabel: string;
    dictErrorSubmit: string;
    dictIdentificationCodeError: string;
}

const IdentificationTutorPartialForm = <
    T extends {
        name: string;
        surname: string;
        denominationCompany: string;
        numberCompany: string;
        socialCompany: string;
    },
>({
    values,
    onChange,
    onChangeNumberCompany,
    onKeyDownNumber,
    onBlurNumberCompany,
    errors,
    dictNameLabel,
    dictSurnameLabel,
    dictDenominationCompanyLabel,
    dictNumberCompanyLabel,
    dictSocialCompanyLabel,
    dictErrorSubmit,
    dictIdentificationCodeError,
}: IdentificationTutorPartialFormProps<T>) => {
    return (
        <div className="row">
            <div className="col-7">
                <FloatLabel
                    active={!!values.denominationCompany}
                    label={dictDenominationCompanyLabel}
                    labelId="denominationCompany"
                >
                    <input
                        type="text"
                        name="denominationCompany"
                        value={values.denominationCompany}
                        onChange={(e) =>
                            onChange('denominationCompany', e.target.value)
                        }
                    />
                </FloatLabel>
                {errors?.denominationCompany && (
                    <div className="row">
                        <label className="alert-danger m-auto">
                            {dictErrorSubmit}
                        </label>
                    </div>
                )}
            </div>

            <div className="col-5">
                <FloatLabel
                    active={!!values.numberCompany}
                    label={dictNumberCompanyLabel}
                    labelId="numberCompany"
                >
                    <input
                        type="text"
                        name="numberCompany"
                        value={values.numberCompany}
                        onChange={(e) =>
                            onChangeNumberCompany
                                ? onChangeNumberCompany(e.target.value)
                                : onChange('numberCompany', e.target.value)
                        }
                        onKeyDown={onKeyDownNumber}
                        onBlur={onBlurNumberCompany}
                    />
                </FloatLabel>
                {errors?.numberCompany && (
                    <div className="row">
                        <label className="alert-danger m-auto">
                            {dictErrorSubmit}
                        </label>
                    </div>
                )}
                {values.numberCompany &&
                    values.numberCompany.length < 12 &&
                    errors?.numberCompany && (
                        <div className="row">
                            <label className="alert-danger m-auto">
                                {dictIdentificationCodeError}
                            </label>
                        </div>
                    )}
            </div>
            <div className="col-10">
                <FloatLabel
                    active={!!values.socialCompany}
                    label={dictSocialCompanyLabel}
                    labelId="socialCompany"
                >
                    <input
                        type="text"
                        name="socialCompany"
                        value={values.socialCompany}
                        onChange={(e) =>
                            onChange('socialCompany', e.target.value)
                        }
                    />
                </FloatLabel>
                {errors?.socialCompany && (
                    <div className="row">
                        <label className="alert-danger m-auto">
                            {dictErrorSubmit}
                        </label>
                    </div>
                )}
            </div>
            <div className="col-10">
                <FloatLabel
                    active={!!values.name}
                    label={dictNameLabel}
                    labelId="name"
                >
                    <input
                        type="text"
                        name="name"
                        value={values.name}
                        onChange={(e) => onChange('name', e.target.value)}
                    />
                </FloatLabel>
                {errors?.name && (
                    <div className="row">
                        <label className="alert-danger m-auto">
                            {dictErrorSubmit}
                        </label>
                    </div>
                )}
            </div>

            <div className="col-10">
                <FloatLabel
                    active={!!values.surname}
                    label={dictSurnameLabel}
                    labelId="surname"
                >
                    <input
                        type="text"
                        name="surname"
                        value={values.surname}
                        onChange={(e) => onChange('surname', e.target.value)}
                    />
                </FloatLabel>
                {errors?.surname && (
                    <div className="row">
                        <label className="alert-danger m-auto">
                            {dictErrorSubmit}
                        </label>
                    </div>
                )}
            </div>
        </div>
    );
};

export default IdentificationTutorPartialForm;
